import { Component } from '@angular/core';

@Component({
    selector: 'saf-terminal-page-polling-view',
    templateUrl: './terminal-page-polling-view.component.html',
    styleUrls: ['./terminal-page-polling-view.component.scss'],
    standalone: false
})
export class TerminalPagePollingViewComponent{}
